module.exports = function() {
  return new Worker(__webpack_public_path__ + "42aeedacb28d0d71e6d6.worker.js");
};